import { AffiliationType, RSAssignmentCandidate, RSContractorAssignmentCandidate } from '@/api/apis/resources';
import { ContractorSurgeonsTable } from './ContractorSurgeons/ContractorSurgeonsTable';
import { EmployeeSurgeonsTable } from './EmployeeSurgeons/EmployeeSurgeonsTable';
import { SurgeonTableBaseProps } from './types';

type SurgeonsTableProps = SurgeonTableBaseProps & {
  isContractor: boolean;
  affiliation?: AffiliationType;
  onContractorReserve: (surgeon: RSContractorAssignmentCandidate) => void;
  onEmployeeReserve: (surgeon: RSAssignmentCandidate) => void;
};

export const SurgeonsTable = ({
  searchTerm,
  caseId,
  caseName,
  orTime,
  organ,
  donor,
  isLogistics,
  selectedSurgeonsIds,
  isContractor,
  affiliation,
  onContractorReserve,
  onEmployeeReserve,
}: SurgeonsTableProps) => {
  const commonProps = { searchTerm, caseId, caseName, orTime, organ, donor, isLogistics, selectedSurgeonsIds };

  return isContractor ? (
    <ContractorSurgeonsTable affiliation={affiliation} onReserve={onContractorReserve} {...commonProps} />
  ) : (
    <EmployeeSurgeonsTable onReserve={onEmployeeReserve} {...commonProps} />
  );
};
